module.exports = __webpack_public_path__ + "img/Merchandise-Filled.e0d693a8.svg";